import React from 'react';
import { renderProcessedText } from '../../utils/textRenderer';

interface UsageCardProps {
  title: string;
  metrics: Array<{
    icon: 'clock' | 'devices' | 'video' | 'data';
    value: string;
    description: string;
  }>;
  isCarousel?: boolean;
}

const UsageCard: React.FC<UsageCardProps> = ({ title, metrics, isCarousel })  => {
  const renderIcon = (iconType: string) => {
    switch (iconType) {
      case 'clock':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'devices':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
            <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" strokeWidth="2"/>
            <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" strokeWidth="2"/>
          </svg>
        );
      case 'video':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon points="23 7 16 12 23 17 23 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
          </svg>
        );
      case 'data':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="12" cy="5" rx="9" ry="3" stroke="currentColor" strokeWidth="2"/>
            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="currentColor" strokeWidth="2"/>
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="currentColor" strokeWidth="2"/>
          </svg>
        );
      default:
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          </svg>
        );
    }
  };

  return (
    <div className="usage-card" style={{ height: isCarousel ? '100%' : 'auto' }}>
      <div className="usage-card__container">
        <h3 className="usage-card__title">{renderProcessedText(title)}</h3>
        <div className="usage-card__metrics">
          {metrics.map((metric, index) => (
            <div key={index} className="usage-card__metric">
              <div className="usage-card__icon">
                {renderIcon(metric.icon)}
              </div>
              <div className="usage-card__content">
                <div className="usage-card__value">{renderProcessedText(metric.value)}</div>
                <div className="usage-card__description">{renderProcessedText(metric.description)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UsageCard;
